//const api_url = "http://localhost:8000"
const api_url = "http://192.168.0.117:8000"
export { api_url }